const intitalState = {
  news: null,
  loadingNews : false,
  loadingNewsTypes: false,
  endOfNewsReached: false,
  nbOfNews: 0,
  news_details: null
};

export const newsReducers = (state = intitalState, action) => {
  switch (action.type) {

    case "GET_NEWS_LOADING":
      return {
        ...state,
        loadingNews: true,
      };


      case "CLEAR_TYPE_DETAILS":
        return {
          ...state,
          news: null,
          nbOfNews: 0,
          news_details: null
        };



      case "GET_NEWS_TYPES_LOADING":
        return {
          ...state,
          loadingNewsTypes: true,
        };


    case "GET_NEWS_SUCCESS":
      return {
        ...state,
        news: action.news,
        loadingNews: false,
        nbOfNews: action.nbOfNews,
        endOfNewsReached: action.endOfNewsReached
      };


      case "GET_NEWS_TYPES_SUCCESS":
        return {
          ...state,
          news_types: action.news_types,
          loadingNewsTypes: false,
        };


    case "GET_MORE_NEWS_SUCCESS":
      let news = state.news.concat(action.news);
      return {
        ...state,
        news: news,
        loadingNews: false,
        nbOfNews: action.nbOfNews,
        endOfNewsReached: action.endOfNewsReached
      };


    case 'GET_NEWS_DETAILS_SUCCESS' :
    return {
      ...state,
      news_details: action.news_details
    }

    default:
      return state;
  }
};
